
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"29.6","cy":"44.42","r":"1.5","fill":"#241f21"}}),_c('path',{attrs:{"d":"M22.35 25.77s-.28-8.45 8.26-8.45c7.68 0 9.39 9.39 3.41 12.8-4.75 2.72-4.44 4-4.44 9.28","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"30","cy":"30","r":"28.5","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    